import { Img } from "components";
import { Section } from "./component/section";
import { BenefitItem } from "../AIReelGenration/components/benefit-item";

export default function AIBasedParental() {
    return (
        <main className="mx-auto max-w-7xl px-6 py-20 sm:py-16">
            <header className="mb-20 sm:mb-14">
                <h1 className="text-center text-balance text-5xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]">
                    AI-Based Parental Feedback System
                </h1>
            </header>

            <div className="space-y-10 sm:space-y-12">
                <Section
                    title="Cyclical Feedback Collection"
                    items={[
                        "Feedback is collected on a structured cycle — quarterly, half-yearly, and annually.",
                        "Surveys are conducted directly through WhatsApp and mobile apps, making it simple and accessible for all parents.",
                        "Parents are asked about:",
                        "  Changes or improvements they wish to see",
                        "  Their experiences with academics, safety, communication, facilities, etc.",
                        "  Suggestions for how the school can improve",
                    ]}
                />

                <Section
                    title="AI-Driven Analysis & Actionable Reports"
                    items={[
                        "All feedback is analyzed by AI to identify key themes, urgent issues, and improvement areas.",
                        "Schools receive clear, actionable reports that:",
                        "Highlight priority issues raised by parents",
                        "Suggest practical steps for improvement",
                        "  Provide predictive insights such as:",
                        "  Projected attrition rate (number of students who may leave if changes aren't made)",
                        "  Estimated financial/business loss if parental recommendations are ignored",
                    ]}
                />

                <Section
                    title="Implementation & Business Impact"
                    items={[
                        "Schools are guided on how to implement changes based on parent feedback.",
                        "AI links parental concerns with student outcomes and school reputation, showing the direct business impact of taking or ignoring action.",
                    ]}
                />

                <Section
                    title="Closing the Feedback Loop"
                    items={[
                        "Once changes are implemented, parents are personally informed that:",
                        "  Their feedback was valued and acted upon",
                        "  Specific improvements were made because of their input",
                        "This ensures parents feel their voices truly matter, and it is not just a token act to collect testimonials.",
                    ]}
                />
            </div>

            <section className="mt-14 md:mt-10 sm:mt-8">
                <h2 className="text-center text-2xl font-semibold md:text-xl sm:text-lg">
                    Outcome
                </h2>
                <div className="mt-6 flex flex-wrap justify-center gap-6 md:gap-4 sm:mt-4 sm:gap-3">
                    <BenefitItem>Parents feel respected, valued, and more loyal to the school.</BenefitItem>
                    <BenefitItem>Schools gain trust, better retention, stronger reputation, and reduced attrition.</BenefitItem>
                </div>
                <div className="mt-6 flex flex-wrap justify-center gap-6 md:gap-4 sm:mt-3 sm:gap-3">
                    <BenefitItem>Demonstrates a data-driven, parent-centric approach that directly impacts growth and sustainability.</BenefitItem>
                </div>
            </section>
        </main>
    )
}
